import { useOrganizationStore } from '@/stores/organization';

/**
 * Devuelve si un submodulo del bloque Gestion esta activado para la org
 * seleccionada. Politica:
 *   - undefined → habilitado (legacy default, no rompe orgs existentes).
 *   - true      → habilitado.
 *   - false     → deshabilitado.
 *
 * Espejo del backend `requireManagementFeature`.
 */
export function useManagementFeature(
  feature: 'members' | 'fees' | 'budget'
): boolean {
  const selectedOrg = useOrganizationStore((s) => s.selectedOrg);
  const flag = selectedOrg?.config?.management?.[feature]?.enabled;
  return flag !== false;
}
